import React, { useState, useEffect } from "react";
import axios from "axios";
//import { Spinner } from "react-bootstrap";
import Swal from "sweetalert2";
import Spinner from "../LoadingSpinner/loadingSpinner";
import { RiEyeLine, RiEyeOffLine } from "react-icons/ri";
import Cookies from "js-cookie";
import api from "../../api";

const Profilerightcard = ({profileData}) => {
  const [languageData, setLanguageData] = useState(null);
  const [login, setLogin] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [profileStatus, setProfileStatus] = useState(0);
  const baseUrl = process.env.REACT_APP_BASE_URL;

  useEffect(() => {
    const defaultLang = process.env.REACT_APP_LANG;
    const cookieLang =
      localStorage.getItem("lang") ||
      document.cookie
        .split("; ")
        .find((row) => row.startsWith("lang="))
        ?.split("=")[1] ||
      defaultLang;

    if (cookieLang) {
      import(`../../lang/profile/${cookieLang}.json`)
        .then((data) => {
          setLanguageData(data);
        })
        .catch((error) => {
          console.error("Error loading language file:", error);
        });
    } else {
      console.warn("Language cookie 'lang' not found.");
    }

  }, []);

    useEffect(() => {
  if (!profileData) return;

    const user = profileData;
   setProfileStatus(Number(user.profile_status || 0));
  
  }, [profileData]);

  const CloseAccount = async () => {
    const userToken = localStorage.getItem(
      `${process.env.REACT_APP_LOCAL_TOKEN}`,
    );

    if (!userToken) {
      Swal.fire(
        languageData?.alert?.remove_account?.token_error?.title,
        languageData?.alert?.remove_account?.token_error?.description,
        "error",
      );
      return;
    }
    const result = await Swal.fire({
      title: languageData?.alert?.remove_account?.title,
      text: languageData?.alert?.remove_account?.description,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: languageData?.alert?.remove_account?.confirm_button,
      cancelButtonText: languageData?.alert?.remove_account?.cancel_button,
    });

    if (!result.isConfirmed) return;

    try {
      setLoading(true);

      await api.delete(`/accounts/close`);

      document.cookie = "log=; max-age=0; path=/";
      localStorage.removeItem(process.env.REACT_APP_LOCAL_TOKEN);
      Cookies.remove(process.env.REACT_APP_SESSION_ID);
      Cookies.remove(process.env.REACT_APP_LEAD_ID);

      Swal.fire(
        languageData?.alert?.success_close_account?.title,
        languageData?.alert?.success_close_account?.description,
        "success",
      );
      setLoading(false);
      window.location.href = "/signin";
    } catch (error) {
      setLoading(false);
      console.log(error);
      Swal.fire(
        languageData?.alert?.error_close_account?.title,
        languageData?.alert?.error_close_account?.description,
        "error",
      );
    }
  };

  const handleUpdateCredential = async () => {
    if (!password || !confirmPassword) {
      Swal.fire({
        title: languageData?.alert?.credentials_error?.inputs.title,
        icon: "error",
      });
      return;
    }
    if (password !== confirmPassword) {
      Swal.fire({
        title: languageData?.alert?.credentials_error?.password_mismatch.title,
        icon: "error",
      });
      return;
    }
    try {
      setLoading(true);

      const response = await api.post(`/accounts/credentials/update`, {
        current_login: login,
        login: login,
        password: password,
      });
      if (response.data?.status === "success") {
        localStorage.setItem(
          process.env.REACT_APP_LOCAL_TOKEN,
          JSON.stringify({
            token: response.data.data.token,
          }),
        );
        localStorage.setItem(
          `${process.env.REACT_APP_REFRESH_TOKEN}`,
          response.data.data.refresh_token,
        );
      }
      Swal.fire(
        languageData?.alert?.credentials_success?.title,
        languageData?.alert?.credentials_success?.description,
        "success",
      );
      console.log("Profile updated successfully", response.data);
    } catch (error) {
      Swal.fire(
        languageData?.alert?.credentials_error?.inputs?.title,
        "",
        "error",
      );
      console.error("Error updating profile:", error);
    } finally {
      setLoading(false);
    }
  };
  if (!languageData) {
    return <div></div>;
  }

  return (
    <div className="col-xxl-3 text-start">
      <div className="card custom-card">
        <div>
          <div className="p-4 border-bottom border-block-end-dashed">
            <div>
              <p className="fs-15 mb-2 fw-semibold">
                {languageData.header.profile_status} :
              </p>
              <p className="fw-semibold mb-2">
                {languageData.header.profile} {profileStatus}%{" "}
                {languageData.header.completed}
              </p>
              <div className="progress progress-sm progress-animate">
                <div
                  className="progress-bar bg-primary rounded-1"
                  role="progressbar"
                  aria-valuenow={profileStatus}
                  aria-valuemin="0"
                  aria-valuemax="100"
                  style={{ width: `${profileStatus}%` }}
                ></div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="card custom-card">
        <div>
          <div className="p-4 border-bottom border-block-end-dashed">
            <p className="fs-15 mb-2 me-4 fw-semibold">
              {languageData.auth.title} :
            </p>
            <div className="password-form">
              <div className="mb-3">
                <label for="form-text1" className="form-label fs-14 text-dark">
                  {languageData.auth.login}
                </label>
                <div className="input-group">
                  <div className="input-group-text">
                    <i className="ri-user-line"></i>
                  </div>
                  <input
                    type="text"
                    className="form-control"
                    id="form-text1"
                    name="login"
                    placeholder={languageData.auth.login_placeholder}
                    value={login}
                    onChange={(e) => setLogin(e.target.value)}
                  />
                </div>
              </div>
              <div className="mb-3">
                <label
                  for="form-password1"
                  className="form-label fs-14 text-dark"
                >
                  {languageData.auth.new_password}
                </label>
                <div className="input-group">
                  <div className="input-group-text">
                    <i className="ri-lock-line"></i>
                  </div>
                  <input
                    type={showPassword ? "text" : "password"}
                    className="form-control"
                    id="form-password1"
                    name="password"
                    placeholder={languageData.auth.new_password_placeholder}
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                  />
                  <span className="pass_input"
                    onClick={() => setShowPassword(!showPassword)}
                 
                  >
                    {showPassword ? (
                      <RiEyeOffLine size={15} />
                    ) : (
                      <RiEyeLine size={15} />
                    )}
                  </span>
                </div>
              </div>
              <div className="mb-3">
                <label
                  for="form-password1"
                  className="form-label fs-14 text-dark"
                >
                  {languageData.auth.confirm_password}
                </label>
                <div className="input-group">
                  <div className="input-group-text">
                    <i className="ri-lock-line"></i>
                  </div>
                  <input
                    type={showConfirmPassword ? "text" : "password"}
                    className="form-control"
                    id="form-password1"
                    name="confirm_password"
                    placeholder={languageData.auth.confirm_placeholder}
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                  />
                  <span className="pass_input"
                    onClick={() => setShowConfirmPassword(!showConfirmPassword)} 
                  >
                    {showConfirmPassword ? (
                      <RiEyeOffLine size={15} />
                    ) : (
                      <RiEyeLine size={15} />
                    )}
                  </span>
                </div>
              </div>
              <button data-interaction="update_credential_button"
                className="btn btn-primary"
                type="submit"
                onClick={handleUpdateCredential}
              >
                {languageData.auth.button}
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className="card custom-card">
        <div>
          <div className="p-4 border-bottom border-block-end-dashed">
            <div>
              <p className="fs-15 mb-2 fw-semibold">
                {languageData.account.title}
              </p>
              <button data-interaction="close_account_button"
                type="button"
                className="btn btn-light flex"
                onClick={CloseAccount}
              >
                <i className="ri-forbid-line pe-2"></i>
                <span> {languageData.account.button} </span>
              </button>
            </div>
          </div>
        </div>
      </div>
      {/* Spinner Overlay */}
      {loading && (
        <div className="spinner-overlay">
          <Spinner />
        </div>
      )}
    </div>
  );
};

export default Profilerightcard;
